import React from 'react';
import styles from './ThumbnailProduct.module.scss';

interface Codification {
  code: string;
  topic: string;
  topicCode: string;
  label: string;
  filter: string;
}

interface iThumbnailProduct {
  id: number;
  name: string;
  photo: string | null;
  logo: string | null;
  format: string;
  alcool: string;
  millesime: string;
  raison_sociale: string;
  codifications: Codification[];
  hall: string;
  stand: string;
  slug: string;
}

export default function ThumbnailProduct({
  id,
  name,
  photo,
  format,
  logo,
  alcool,
  millesime,
  codifications,
  raison_sociale,
  hall,
  stand,
  slug,
}: iThumbnailProduct): JSX.Element {
  const formatLabel = codifications.find(
    ({ topicCode }) => topicCode === format
  )?.label;

  const alcoolCodif = codifications.find(
    ({ topicCode }) => topicCode === alcool
  );
  const alcoolLabel = alcoolCodif
    ? alcoolCodif.code === 'NO_ALCOHOL'
      ? alcoolCodif?.label
      : `${alcoolCodif?.label}%`
    : undefined;

  const millesimeCodif = codifications.find(
    ({ topicCode }) => topicCode === millesime
  );
  const millesimeLabel =
    millesimeCodif &&
    !['NE_CONCERNE_PAS_MON_PRODUIT', 'NV'].includes(millesimeCodif.code)
      ? millesimeCodif.label
      : undefined;

  const BASE_PATH = window.location.pathname.split('/')[1];

  return (
    <div className={styles.ThumbnailProduct}>
      <a
        href={`/${BASE_PATH}/preview/events/${slug}/products/${id}`}
        className={styles.ThumbnailProduct__link}
      >
        <div className={styles.ThumbnailProduct__bootle}>
          {photo && (
            <img
              src={photo}
              alt=""
              width={100}
              height={180}
              className={styles.ThumbnailProduct__bootle__img}
            />
          )}
        </div>
        <div className={styles.ThumbnailProduct__content}>
          <div>
            <img className={styles.ThumbnailProduct__content__heart} />
            <div className={styles.ThumbnailProduct__content__title}>
              {name}
            </div>
            <div className={styles.ThumbnailProduct__content__info}>
              {[formatLabel, alcoolLabel].filter(Boolean).join(' / ')}{' '}
              <span>{millesimeLabel}</span>
            </div>
            <div className={styles.ThumbnailProduct__content__name}>
              {raison_sociale}
            </div>
          </div>
          {logo && (
            <img
              src={logo}
              alt=""
              width={200}
              height={112}
              className={styles.ThumbnailProduct__content__logo}
            />
          )}
        </div>
      </a>
      {hall && stand && (
        <a
          href={`/floormap#${hall}${stand}`}
          className={styles.ThumbnailProduct__content__booth}
        >
          <span>Hall</span> {hall} <span>Booth</span> {hall}
          {stand}
        </a>
      )}
    </div>
  );
}
